import { ClientPortalTimesheetEntry } from "../../../interfaces/ClientPortal";

export interface GrupoProjeto {
  projeto: string;
  linhas: ClientPortalTimesheetEntry[];
  subtotal: number;
}

// Soma decimal acumula erro de ponto flutuante; arredonda uma vez, no fim.
export const soma = (ns: number[]) => Math.round(ns.reduce((s, n) => s + (n ?? 0), 0) * 100) / 100;

/**
 * Agrupa as linhas de horas de um mês por projeto, para o PDF fechar cada bloco com um subtotal.
 * Os grupos seguem o primeiro dia em que o projeto aparece (o leitor continua lendo o mês em ordem);
 * dentro do grupo, por dia, preservando a ordem de entrada entre linhas do mesmo dia.
 */
export function agruparPorProjeto(linhas: ClientPortalTimesheetEntry[]): GrupoProjeto[] {
  const porDia = linhas.slice().sort((a, b) => a.day - b.day);
  const grupos = new Map<string, ClientPortalTimesheetEntry[]>();
  for (const linha of porDia) {
    const chave = linha.projectName ?? "";
    const grupo = grupos.get(chave);
    if (grupo) grupo.push(linha);
    else grupos.set(chave, [linha]);
  }
  return Array.from(grupos, ([projeto, ls]) => ({ projeto, linhas: ls, subtotal: soma(ls.map((e) => e.hours)) }));
}
